"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyPremiumProfileContentType = void 0;
var CompanyPremiumProfileContentType;
(function (CompanyPremiumProfileContentType) {
    CompanyPremiumProfileContentType["profile"] = "profile";
    CompanyPremiumProfileContentType["offers"] = "offers";
})(CompanyPremiumProfileContentType || (exports.CompanyPremiumProfileContentType = CompanyPremiumProfileContentType = {}));
